import React from 'react'
import Modal from '../../controls/Modal'
import LodingButton from '../../controls/LodingButton'

export default function WarningPopUp({ isOpen, setIsOpen, call, loding, text }) {

    return (
        <Modal isOpen={isOpen} setIsOpen={setIsOpen} title={"Confirm"}>
            <div>
                <div class="p-6 space-y-6">
                    <div class="grid grid-cols gap-6">
                        <div class="col-span-12">
                            <h1 className="text-lg text-center">{text}</h1>
                        </div>
                    </div>
                </div>
                <div class="flex items-center p-6 space-x-3 rtl:space-x-reverse border-t border-gray-200 rounded-b ">
                    {!loding ?
                        <>
                            <button type="submit" onClick={call} className="btn-blue">Yes</button>
                            <button onClick={(e) => { setIsOpen(false) }} className="btn-default" >Cancel</button>
                        </>
                        : <LodingButton text="Wait.." css='btn-danger-disabled' />
                    }
                </div>
            </div>
        </Modal>
    )
}
